module.exports = __webpack_public_path__ + "static/media/icon-gift-white.41fe7eb1.svg";